/**
 * Created by nijin on 8/2/17.
 */
export const environment = {
  production: false,
  serviceBase: 'http://gateway.staging.nucleus.CantizAI.com:8080',
  eventURI: 'http://events.staging.nucleus.CantizAI.com:8010/device/event',
  middleURI: 'http://52.209.2.52:8080/accounts/:accountId/things',
  latestEventURI: 'http://gateway.staging.nucleus.CantizAI.com:8080/accounts/:accountId/events/latest',
  stompUrl: 'http://52.213.29.134:8012/nucleus',
  devDocUrl:'http://staging.api.CantizAI.com',
  electronDownloadLinks: {
    withOs: 'https://www.dropbox.com/s/r6p96deotbfbpp9/CantizAI-electron-withOS.tar.gz?dl=0',
    withoutOs: 'https://www.dropbox.com/s/fis2291ktg0ka5q/CantizAI-electron-withoutOS_S.tar.gz?dl=0"'
  },
  auth: {
    clientId: 'NucleusWebQA',
    site: 'https://identity.CantizAI.com:446/qa/ids/v1.1.0_23/', //'https://identity.CantizAI.com:447/',
    authPath: 'connect/authorize',
    redirectUri: 'http://staging.nucleus.CantizAI.com/intro',
    logoutUri: 'http://staging.nucleus.CantizAI.com',
    scope: 'openid CantizAIUserManagementApi',
    endSession: 'connect/endsession'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts